// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2LKc3","name":"ConsentHeader_name__1qJ5H","birthday":"ConsentHeader_birthday__3RNq4","skeleton":"ConsentHeader_skeleton__byqFa"};